import { useFormik } from 'formik';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { getErrorMessage } from 'utils/utilities';
import { selectReauthSessionId } from 'features/reauthenticate/state';
import { useSendEmailLinkMutation, useSendReauthEmailLinkMutation } from 'features/common/api';
import validationSchema from './Email.validation';

const initialValues = {
    email: '',
};

export default function useEmailForm({ isReauthenticate, onSent }) {
    const reAuthenticateSessionId = useSelector(selectReauthSessionId);
    const [sendEmailLink] = useSendEmailLinkMutation();
    const [sendReauthEmailLink] = useSendReauthEmailLinkMutation();

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                if (isReauthenticate) {
                    await sendReauthEmailLink({
                        sessionId: reAuthenticateSessionId,
                        ...values,
                    }).unwrap();
                } else {
                    await sendEmailLink(values).unwrap();
                }
            } catch (error) {
                toast.error(getErrorMessage({ response: { data: error?.data } }));
                return;
            } finally {
                setSubmitting(false);
            }

            /**
             * Outside the try, and that is the point: by here the link has been sent. Anything this
             * throws is the caller's business, not the request's, and reporting it as a failed send
             * tells the user the opposite of what happened — they get an error while the email is
             * already arriving, and nothing shows up in the network tab to explain it.
             */
            onSent();
        },
    });

    return { formik };
}
